import type { ContestVO } from '~/types/auto/oj';
import type { IdNameOption, Pagination } from '~/types/common';
import type {
  AnnouncementListVO,
  ContestDetailProblemVO,
  ContestDetailScoreResponseVo,
  ContestInfoRequestVo,
  ContestInfoVO,
  ContestListRequestVO,
  GatherInfoVO,
  PreGatherInfoVO,
} from '~/types/contest';
import { httpService } from '../http';

export function getContestList(query?: ContestListRequestVO) {
  return httpService.get<Pagination<ContestVO>>(
    `/api/code-community/api/get-contest-list`,
    { query },
  );
}

export function getContestDetail(id: number) {
  return httpService.get<ContestVO>(
    `/api/code-community/api/get-contest-detail`,
    { query: { id } },
  );
}

export function getTypeList() {
  return httpService.get<IdNameOption[]>(
    `/api/code-community/api/get-contest-type-list`,
  );
}
export function getStatusList() {
  return httpService.get<IdNameOption[]>(
    `/api/code-community/api/get-contest-status-list`,
  );
}

export function getContestInfo(query: ContestInfoRequestVo) {
  return httpService.get<ContestVO>(
    `/api/code-community/api/get-contest-info`,
    { query },
  );
}
export function getContestScoreboard(query: ContestInfoRequestVo) {
  return httpService.get<Pagination<ContestDetailScoreResponseVo>>(
    `/api/code-community/api/get-contest-scoreboard`,
    {
      query,
    },
  );
}

export function getContestProblem(query: ContestInfoRequestVo) {
  return httpService.get<Pagination<ContestDetailProblemVO>>(
    `/api/code-community/api/get-contest-problem`,
    {
      query,
    },
  );
}
export function getContestAnnouncement(query: ContestInfoRequestVo) {
  return httpService.get<Pagination<AnnouncementListVO>>(
    `/api/code-community/api/get-contest-announcement`,
    {
      query,
    },
  );
}

export function toggleArticleLike(aid: number, toLike: boolean) {
  return httpService.get(`/api/code-community/api/contest-announcement-like`, {
    query: { aid, toLike },
  });
}

export function getContestAccess(cid: number) {
  return httpService.get<{ access: boolean }>(
    `/api/code-community/api/get-contest-access`,
    {
      query: {
        cid,
      },
    },
  );
}
export function registerContest(data: {
  cid: number;
  password?: string;
  gid?: number;
}) {
  return httpService.post<{ registerState: number }>(
    `/api/code-community/api/register-contest`,
    {
      body: data,
    },
  );
}

export function startContest(data: { cid: number; gid?: number }) {
  return httpService.post(`/api/code-community/api/start-contest`, {
    body: data,
  });
}

export function preGatherInfo(data: {
  cid?: number;
  gid?: number;
  gatherType?: number;
}) {
  return httpService.post<PreGatherInfoVO>(
    `/api/code-community/api/pre-gather-info`,
    {
      body: data,
    },
  );
}

export function gatherInfo(data: GatherInfoVO) {
  return httpService.post<{ registerState: number }>(
    `/api/code-community/api/gather-info`,
    {
      body: data,
    },
  );
}

export function getContestDiscussion() {
  return httpService.get(`/api/code-community/api/contest-discussion`);
}
